import CustomSelect from "components/customs/dropdown";
import { dropdownSelectStyle } from "constants/style";
import React, { useState } from "react";
import { UserPlus, Download } from "react-feather";
import styled from "styled-components";
import ToggleSwitch from "components/customs/toggle-switch";
import { AddButton } from "assets/js/Styles";
import { hasPermission } from "utility/helpers";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";

const Wrapper = styled.div`
  margin-top: 44px;
`;

const AddSection = styled.div`
  display: flex;
  gap: 8px;
`;

const ExportSection = styled.div`
  display: flex;
  width: 130px;

  @media (max-width: 1265px) {
    width: 100%;
  }
`;

const ToggleLabel = styled.label`
  margin-bottom: 0;
  font-weight: 400;
  font-size: 14px;
  color: #333;
`;

const StyledAddButton = styled(AddButton)`
  width: 130px;
  background: ${({ theme }) => theme.colors.buttonBlue};

  @media (max-width: 1265px) {
    width: 100%;
  }
`;

const StyledExportDropdownToggle = styled(DropdownToggle)`
  width: 130px;
  height: clamp(35px, 5vw, 50px);
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent !important;
  border: 2px solid ${({ theme }) => theme.colors.systemBlue} !important;
  padding: 0 16px !important;
  color: ${({ theme }) => theme.colors.systemBlue} !important;
  font-weight: 500;
  letter-spacing: 0.63px;

  @media (max-width: 1265px) {
    width: 100%;
  }

  svg {
    color: ${({ theme }) => theme.colors.systemBlue};
  }

  &:focus {
    box-shadow: none !important;
  }

  &:hover {
    background: transparent !important;
    border-color: ${({ theme }) => theme.colors.systemBlue} !important;
    color: ${({ theme }) => theme.colors.systemBlue} !important;
    opacity: 0.85;

    svg {
      color: ${({ theme }) => theme.colors.systemBlue};
    }
  }

  &:active {
    background: transparent !important;
    color: ${({ theme }) => theme.colors.systemBlue} !important;
  }
`;

const StyledDropdownMenu = styled(DropdownMenu)`
  min-width: 150px;
`;

const ToggleFilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  height: clamp(35px, 5vw, 50px);
  border: 2px solid #e8edf8;
  border-radius: 9px;
  padding: 0 1rem;
  background: white;
`;

const Container = styled.div`
  padding: 0;
  display: grid;
  gap: 16px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 130px 130px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 768.98px) and (max-width: 1265px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const AddButtonText = styled.span`
  padding-left: 8px;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.63px;
`;

const CommitteeFilters = ({
  committees,
  selectedCommittee,
  setSelectedCommittee,
  setTableOption,
  houseMembers,
  selectedHouseMember,
  setSelectedHouseMember,
  selectedRegion,
  setSelectedRegion,
  regions,
  selectedAffiliation,
  affiliations,
  setSelectedAffiliation,
  toggleModal,
  showChairpersonOnly,
  setShowChairpersonOnly,
  tableOption,
  onExport,
}) => {
  const [exportDropdownOpen, setExportDropdownOpen] = useState(false);

  const toggleExportDropdown = () => setExportDropdownOpen((prev) => !prev);

  const handleExport = (format) => {
    if (onExport) {
      onExport(format);
    }
    setExportDropdownOpen(false);
  };

  return (
    <Wrapper>
      <Container>
        <CustomSelect
          placeholder="Committee"
          isClearable
          value={selectedCommittee}
          onChange={(option) => {
            setSelectedCommittee(option);
            setTableOption((prev) => ({ ...prev, page: 1, offset: 0 }));
          }}
          options={committees}
          styles={dropdownSelectStyle}
          isDisabled={tableOption.isLoading}
        />
        <CustomSelect
          placeholder="House Member"
          isClearable
          value={selectedHouseMember}
          onChange={(option) => {
            setSelectedHouseMember(option);
            setTableOption((prev) => ({ ...prev, page: 1, offset: 0 }));
          }}
          options={houseMembers}
          styles={dropdownSelectStyle}
          isDisabled={tableOption.isLoading}
        />
        <CustomSelect
          placeholder="Region"
          isClearable
          value={selectedRegion}
          onChange={(option) => {
            setSelectedRegion(option);
            setTableOption((prev) => ({ ...prev, page: 1, offset: 0 }));
          }}
          options={regions}
          styles={dropdownSelectStyle}
          isDisabled={tableOption.isLoading}
        />
        <CustomSelect
          placeholder="Affiliation"
          isClearable
          value={selectedAffiliation}
          onChange={(option) => {
            setSelectedAffiliation(option);
            setTableOption((prev) => ({ ...prev, page: 1, offset: 0 }));
          }}
          options={affiliations}
          styles={dropdownSelectStyle}
          isDisabled={tableOption.isLoading}
        />
        <ToggleFilterContainer>
          <ToggleLabel>{"Chairperson"}</ToggleLabel>
          <ToggleSwitch
            id="chairperson-filter"
            name="chairperson-filter"
            checked={showChairpersonOnly}
            disabled={tableOption.isLoading}
            onChange={(e) => {
              setShowChairpersonOnly(e.target.checked);
              setTableOption((prev) => ({ ...prev, page: 1, offset: 0 }));
            }}
          />
        </ToggleFilterContainer>
        <ExportSection>
          <Dropdown
            isOpen={exportDropdownOpen}
            toggle={toggleExportDropdown}
            disabled={tableOption.isLoading}
          >
            <StyledExportDropdownToggle disabled={tableOption.isLoading}>
              <Download size={24} />
              <AddButtonText>{"Export"}</AddButtonText>
            </StyledExportDropdownToggle>
            <StyledDropdownMenu>
              <DropdownItem onClick={() => handleExport("pdf")}>
                {"PDF"}
              </DropdownItem>
              <DropdownItem onClick={() => handleExport("docx")}>
                {"DOCx"}
              </DropdownItem>
            </StyledDropdownMenu>
          </Dropdown>
        </ExportSection>
        {hasPermission("membership-committee-create") && (
          <AddSection>
            <StyledAddButton onClick={toggleModal}>
              <UserPlus size={24} />
              <AddButtonText>{"Add"}</AddButtonText>
            </StyledAddButton>
          </AddSection>
        )}
      </Container>
    </Wrapper>
  );
};

export default CommitteeFilters;
